import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* updateHeroColor() {
  try {
    const res = yield call(api, {
      method: 'put',
      url: URL.HERO_COLOR,
    });
    yield put({ type: 'UPDATE_HERO_COLOR_SUCCESS', payload: res.data });
    yield put({ type: 'GET_HERO_COLOR' });
  } catch (e) {
    yield put({ type: 'UPDATE_HERO_COLOR_ERROR' });
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.UPDATE_HERO_COLOR, updateHeroColor);
}
